module.exports = __webpack_public_path__ + "img/curso_sacerdocio_sao_miguel.688168c2.png";